import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c82c4624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-text-field" }
const _hoisted_2 = ["rows", "name"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { computed } from 'vue';
  
  import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-text-field',
  props: {...recProps()},
  setup(__props) {

  const props = __props;

  const asLines = computed(()=> {
    if (!props.description.ivalue) return [];
    return props.description.ivalue.split("\n");
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.description.title)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["text-field-title", [_unref(themingCssClass)('normal')]])
        }, _toDisplayString(_ctx.description.title), 3))
      : _createCommentVNode("", true),
    (!_ctx.description.readonly)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 1,
          rows: _ctx.description.rows,
          name: _ctx.description.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description.ivalue) = $event))
        }, null, 8, _hoisted_2)), [
          [_vModelText, _ctx.description.ivalue]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("p", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(asLines.value, (line, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (_ctx.description.readonly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(line), 1))
            : _createCommentVNode("", true),
          _hoisted_4
        ], 64))
      }), 128))
    ])
  ]))
}
}

})